import React, { useContext, useEffect, useState } from "react";
import { Col, Row, Form, Input, message, Card, Select, Button, Modal } from "antd";
import { useNavigate } from "react-router-dom";
import "dayjs/locale/en";
import { UploadFile } from "antd/lib/upload";
import Upload from "antd/es/upload";
import { BiSolidInbox, BiUpload } from "react-icons/bi";
import { MdDeleteOutline } from "react-icons/md";
import { AuthContext } from "../../Auth/AuthContext";
import { useParams } from "react-router-dom";
import { getDesignationByID, updateDesignation } from "../../utils/API";
import { ArrowLeftOutlined } from "@ant-design/icons";


interface EditDesignationsModalProps {
  visible: boolean;
  onClose?: () => void;
  onSuccess?: () => void;
  initialValues?: {
    _id: string;  // Add this
    name: string;
  };
}
const EditDesignation: React.FC<EditDesignationsModalProps> = ({
  visible,
  onClose,
  onSuccess,
  initialValues
}) => {
  const navigate = useNavigate();
  const { Option } = Select;
  // const { visible, taskId, onClose, initialValues } = props;
  const { id } = useParams();
  const { authData } = useContext(AuthContext);
  const [form] = Form.useForm(); // Use Form hook to get form instance
  const [isLoading, setIsLoading] = React.useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [Designation, setDesignation] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  const roleId = authData.roleId;


  const fetchDesignation = async () => {
    setLoading(true);
    try {
      const data = await getDesignationByID(id);
      // console.log("Fetched Data:", data);

      setDesignation(data);

      form.setFieldsValue({
        name: data.name, // ✅ Ensure correct field name
      });
    } catch (error) {
      // console.error("Error fetching designation:", error);
      message.error("Failed to fetch designation data.");
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    if (visible && initialValues) {
      form.setFieldsValue({
        name: initialValues.name,
      });
    }
  }, [visible, initialValues, form]);
  const handleSubmit = async (values: any) => {
    if (!initialValues || !initialValues._id) {
      message.error("Designation ID is missing!");
      return;
    }

    setIsSaving(true);
    try {
      const updatedData = {
        name: values.name,
      };

      await updateDesignation(initialValues._id, updatedData);
      message.success("Designation updated successfully!");
      onSuccess?.();
      onClose?.();
    } catch (error) {
      message.error("Failed to update designation.");
    } finally {
      setIsSaving(false);
    }
  };


  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={600}
      centered
      destroyOnClose
      className="custom-modal"
      bodyStyle={{
        overflowY: "auto",
        fontFamily: "inter, sans-serif",
      }}
      styles={{
        header: {
          padding: "12px",
          position: "sticky",
          top: 0,
          backgroundColor: "#f1f5ffff",
        },
        content: {
          padding: 0,
          overflow: "hidden",
        },
      }}
      title={
        <div
          style={{
            color: "#4b5563",
            fontFamily: "inter, sans-serif",
            fontSize: "20px",
            fontWeight: 500,
          }}
        >
          Edit Designation
        </div>
      }
    >
      <Form
        onFinish={handleSubmit}
        form={form}
        layout="horizontal"
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 20 }}
        colon={false}
        style={{ margin: 0 }}
      >


        {/* name*/}
        <div className="elements">
          <Col>

            <Form.Item
              label={<label className="Inputlabel">
                <span style={{
                  color: '#4b5563', // Medium gray color similar to the image
                  fontFamily: 'inter, sans-serif', // Matches the clean sans-serif style
                  fontSize: '14px', // Approximate font size based on the image
                  paddingLeft: "15px",
                  fontWeight: 500, // Medium weight to match "font-medium"
                }}>Designation</span>   <span className="text-danger">*</span>
              </label>}
              required={false}
              name="name"
              rules={[
                {
                  required: true,
                  message: "Please Enter Designation",
                },
              ]}
            // optional to remove default margin
            >
              <Input
                size="large"
                disabled={roleId == 2}
                className="Allinput"
                placeholder="Designation"

              />
            </Form.Item>
          </Col>

        </div>
        <Col
          xs={24}
          sm={24}
          md={24}
          xl={24}
          xxl={20}
          className="d-flex justify-content-end me-3 mt-2"
        >
          <div className="button-wrapper">
            <button
              className="allcanclebutton"
              type="button" // Explicitly set to button type
              onClick={(e) => {
                e.preventDefault();
                onClose?.();
              }}
              disabled={isLoading}
            >
              Cancel
            </button>
            <button
              className="allsubmitebutton w-44"
              type="submit" // Explicit submit button
              disabled={isLoading || isSaving}
            >
              {isLoading ? "Updating..." : "Update"}
            </button>
          </div>
        </Col>

      </Form>
    </Modal >
  );
};

export default EditDesignation;